export default __webpack_public_path__ + "static/media/template16.a5aa4a1f.svg";